import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { setSelectedBlog } from '../../store/reducer/blogReducer';
import { getBlogPath, getBlogTitle } from '../../utils/blog';

function BlogL3() {
    const location = useLocation();
    const dispatch = useDispatch()
    const blogs = useSelector((state) => state.blog.blogItems);
    console.log(blogs);
    return (
        <>
            <section className="bg-dark mt-n10 py-10">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mt-6 mt-md-0">
                            <div>
                                <h2 className="text-white" ><span className="font-w-4 d-block" style={{color:"black"}}>From Our Blog</span> <span style={{color:"black"}}>List Latest Feed</span></h2>
                                <p className="lead mb-0 text-light"><span style={{color:"black"}}>Tech Docs & Announcements</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="pt-0 mt-n8">
                <div className="container">
                    {/* <!-- / .row --> */}
                    <div className="row">
                        <div className="col">
                            {/* <!-- Blog Card --> */}
                            {
                                blogs.slice(0, 2).map((blog) => {
                                    return (
                                        <>

                                            <div className="card border-0 flex-md-row align-items-center mb-5">
                                                <div className="col-md-4">
                                                    <img
                                                        className="img-fluid"
                                                        src={require(`../../assets/images/blog/${blog.image.split('/')[3]}`)}
                                                        alt="Image1"
                                                    />
                                                </div>
                                                <div className="card-body col-md-6">
                                                    <div className="d-inline-block  ">
                                                        <span className="text-primary bg-light text-center px-2 py-1 rounded me-2">{blog.date}</span>
                                                        <span className="ms-3">{blog.category}</span>
                                                    </div>
                                                    <h2 className="h5 my-3">
                                                        <Link className="d-inline-block btn-link" dir="auto" style={{ unicodeBidi: 'plaintext' }} to={getBlogPath(blog, location.pathname)} onClick={() => { dispatch(setSelectedBlog(blog.id)) }}>
                                                            {getBlogTitle(blog, location.pathname)}
                                                        </Link>
                                                    </h2>
                                                    <ul className="list-inline mb-0">
                                                        <li className="list-inline-item pe-3"> <a href="/" className="list-group-item-action"><i className="lar la-user-circle me-1 text-primary ic-1x"></i> {blog.author}</a>
                                                        </li>
                                                        <li className="list-inline-item pe-3"> <a href="/" className="list-group-item-action"><i className="las la-eye me-1 text-primary ic-1x"></i> {blog.views}</a>
                                                        </li>
                                                        <li className="list-inline-item"> <a href="/" className="list-group-item-action"><i className="lar la-comments me-1 text-primary ic-1x"></i> {blog.comments}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-md-2">
                                                    <Link to="/blog_listing_1" className="btn btn-primary">
                                                        Read More
                                                    </Link>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                            {/* <!-- End Blog Card --> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BlogL3
